import SuccessPage from 'components/new/SuccessPage';
import {
  LP_CAPITAL_ACTION_CREATE,
  LP_REALISATION_CREATE,
} from 'adminConstants/routes';

const RealisationSuccessPage: React.FC = () => {
  return (
    <SuccessPage
      title="Realisation has been added successfully"
      content="The General Ledger has been updated and any cash consideration from this realisation will be available to distribute in your next capital action."
      primaryButton={{
        label: 'Process capital action',
        link: LP_CAPITAL_ACTION_CREATE,
      }}
      tertiaryButton={{
        label: 'Add another realisation',
        link: LP_REALISATION_CREATE,
      }}
    />
  );
};

export default RealisationSuccessPage;
